export default "__VITE_ASSET__DVhftgZx__"